<template>
  <naj-modal-2
    ref="viewRequestModal"
    :title="request.onlineComplaintRequestTypeName"
    :width="900"
    :footer="true"
    @onClose="closeModal"
  >
    <v-row class="mt-0">
      <v-col class="ps-0">
        <div>
          <label class="d-block"> {{ local.complaints.complaintDetails.requestLogInfo.requestorName }}</label>
          <span class="mb-0 font-weight-bold">
            {{ applyComplainantName }}
          </span>
        </div>
      </v-col>
      <v-col>
        <div>
          <label class="d-block"> {{ local.complaints.complaintDetails.requestLogInfo.requestDate }}</label>
          <span class="mb-0 font-weight-bold">
            {{ toHijriDate(request.addDate) }}
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <naj-input
        :type-id="formFieldType.textarea"
        :value.sync="request.note"
        :label="local.complaints.complaintDetails.requestLogInfo.details"
        disabled
      ></naj-input>
    </v-row>
    <naj-attachment
      view-mode
      :attachment-list="attachments"
    >
    </naj-attachment>
    <template
      slot="actions"
      slot-scope="{ closeNajModal }"
    >
      <naj-button
        v-if="request.showDeleteRequestButton"
        color="error"
        @click="showConfirmation = true"
      >
        {{ local.complaints.complaintDetails.requestLogInfo.cancelRequest }}
      </naj-button>
      <naj-button
        type="button"
        color="#89743e"
        @click="closeModal"
      >
        {{
          local.common.close
        }}
      </naj-button>
      <naj-confirmation
        :show-modal="showConfirmation"
        color="error"
        :title="local.complaints.complaintDetails.requestLogInfo.cancelRequestConfirmationTitle"
        :message="local.complaints.complaintDetails.requestLogInfo.cancelRequestConfirmationMsg"
        :ok-btn-label="local.common.yes"
        :close-btn-label="local.common.no"
        @ok="proceedDeleteRequest"
        @cancel="showConfirmation = false"
      ></naj-confirmation>
    </template>
  </naj-modal-2>
</template>
<script>
import { toHijriDate } from '@/helpers/utils';
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapComplaintsActions } = createNamespacedHelpers('ComplaintsModule');

export default {
  name: 'ViewRequestModal',
  components: {},
  props: {
    request: {
      type: Object,
      default: () => ({}),
    },
    complaintId: {
      type: String,
      default: () => (null),
    },
    applyComplainantName: {
      type: String,
      default: () => (''),
    },
    modalVisibility: { type: Boolean },
  },
  data() {
    return {
      showConfirmation: false,
      toHijriDate,
    };
  },
  computed: {
    attachments() {
      var attachmentList = [];
      if (this.request.attachment) {
        attachmentList.push({
          ...this.request.attachment,
          fileName: this.request.attachment?.title ? this.request.attachment.title : this.local.complaints.complaintDetails.requestLogInfo.attachmentFileName,
          complaintNo: this.complaintId,
        });
      }
      return attachmentList;
    },
  },
  watch: {
    modalVisibility(newValue) {
      if (newValue) {
        this.$refs.viewRequestModal.show();
      } else {
        this.$refs.viewRequestModal.close();
      }
    },
  },
  mounted() { },
  methods: {
    ...mapComplaintsActions([
      'deleteComplaintRequest',
    ]),
    closeModal() {
      this.$emit('onClose');
    },
    proceedDeleteRequest() {
      var payload = {
        complaintId: this.complaintId,
        requestId: this.request.id,
      };
      this.deleteComplaintRequest(payload)
        .then(({ data }) => {
          if (data) {
            this.toaster.success(this.local.complaints.complaintDetails.requestLogInfo.cancelRequestSucceed);
            this.$emit('onClose');
            this.$emit('updateComplaint');
            this.showConfirmation = false;
          } else {
            this.toaster.error(this.local.complaints.complaintDetails.requestLogInfo.cancelRequestFail);
            this.$emit('onClose');
            this.showConfirmation = false;

          }
        })
        .finally(() => {
        });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .custom-naj-card.v-card {
    border: 1px solid #dee2e6;
    border-right: 2px solid #b69a70;
    border-left: 2px solid #b69a70;
    border-radius: 0;
    padding: 24px;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    box-shadow: none !important;
    p,
    label {
      color: #34675a;
    }
    h4 {
      color: #343a40;
      font-size: 18px;
      margin: 0 0 24px 0;
      .v-icon {
        font-size: 18px;
        color: #343a40;
      }
    }

    .status {
      border-radius: 20px;
      color: white;
      font-size: 12px;
      font-weight: bold;
      float: inline-end;
      padding: 4px 8px;
      &.status-inprogress {
        background-color: #203f39;
      }
      &.status-completed {
        background-color: green;
      }
      &.status-closed {
        background-color: red;
      }
    }
  }
}
</style>
